import styled from '@emotion/styled'
import Popup from 'reactjs-popup'

const StyleTooltip = styled(Popup)`
  cursor: pointer;
  &-content {
    background: #35404d;
    opacity: 0.9;
    color: #fff;
    padding: 0.2rem 1.125rem;
    font-size: 14px;
    border-radius: 3px;
    animation: anim 0.2s;
  }

  &-arrow {
    opacity: 0.9;
    color: #35404d;
    font-size: 12px;
  }
  @keyframes anim {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`
export default StyleTooltip
